function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "menu-icon");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "app-bg",
  transform: "translate(-333.000000, -16.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "menu-icon",
  transform: "translate(333.000000, 16.000000)"
}, React.createElement("path", {
  d: "M0,0 L11,0 C11.5522847,-1.01453063e-16 12,0.44771525 12,1 C12,1.55228475 11.5522847,2 11,2 L3.60555128,2 C3.2107013,2 2.82468592,1.88312395 2.49615088,1.66410059 L0,0 L0,0 Z",
  id: "Rectangle"
}), React.createElement("path", {
  d: "M0,4 L11,4 C11.5522847,4 12,4.44771525 12,5 C12,5.55228475 11.5522847,6 11,6 L3.90832691,6 C3.31605196,6 2.73702888,5.82468592 2.24422632,5.49615088 L0,4 L0,4 Z",
  id: "Rectangle"
}), React.createElement("path", {
  d: "M0,8 L11,8 C11.5522847,8 12,8.44771525 12,9 C12,9.55228475 11.5522847,10 11,10 L3.90832691,10 C3.31605196,10 2.73702888,9.82468592 2.24422632,9.49615088 L0,8 L0,8 Z",
  id: "Rectangle"
}))));

var SvgMenuIcon = function SvgMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-icon.594a1d88.svg";
export { ForwardRef as ReactComponent };